import React from 'react';
import type { FC } from 'react';

interface OrganizationIconProps {
    className?: string;
}

export const OrganizationIcon: FC<OrganizationIconProps> = ({ className }) => {
    return (
        <svg
            className={className}
            width="40"
            height="40"
            viewBox="0 0 30 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <title>Organization Icon</title>
            <circle cx="15" cy="15" r="15" fill="black" />
            <g clipPath="url(#clip0_1965_3559)">
                <path
                    d="M8.33203 22.5002V10.0002C8.33203 9.16683 9.16536 8.3335 9.9987 8.3335H14.1654C14.9987 8.3335 15.832 9.16683 15.832 10.0002V22.5002"
                    stroke="white"
                    strokeLinecap="square"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.332 11.6665H19.9987C20.832 11.6665 21.6654 12.4998 21.6654 13.3332V22.4998"
                    stroke="white"
                    strokeLinecap="square"
                    strokeLinejoin="round"
                />
                <path d="M7.5 22.5H22.5" stroke="white" strokeLinecap="square" strokeLinejoin="round" />
                <path d="M10.3008 12H10.8008" stroke="white" strokeLinecap="square" strokeLinejoin="round" />
                <path d="M13.3984 12H13.8984" stroke="white" strokeLinecap="square" strokeLinejoin="round" />
                <path d="M10.3008 15.3335H10.8008" stroke="white" strokeLinecap="square" strokeLinejoin="round" />
                <path d="M13.3984 15.3335H13.8984" stroke="white" strokeLinecap="square" strokeLinejoin="round" />
                <path d="M10.3008 18.667H10.8008" stroke="white" strokeLinecap="square" strokeLinejoin="round" />
                <path d="M13.3984 18.667H13.8984" stroke="white" strokeLinecap="square" strokeLinejoin="round" />
                <path d="M18.3008 15.3398H18.8008" stroke="white" strokeLinecap="square" strokeLinejoin="round" />
                <path d="M18.3008 18.6733H18.8008" stroke="white" strokeLinecap="square" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_1965_3559">
                    <rect width="20" height="20" fill="white" transform="translate(5 5)" />
                </clipPath>
            </defs>
        </svg>
    );
};
